module.exports = __webpack_public_path__ + "static/img/77.979022c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/77.png
// module id = /WCm
// module chunks = 1